export const space = ({ mt, mr, mb, ml }) => `
  ${mt ? `margin-top: ${mt}px;` : ``}
  ${mr ? `margin-right: ${mr}px;` : ``}
  ${mb ? `margin-bottom: ${mb}px;` : ``}
  ${ml ? `margin-left: ${ml}px;` : ``}
`;

export default space;
